// 第三方模块
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useContext, useEffect } from 'react';
// 内部模块
import { StoreContext } from '@src/store';
import { UserStatusType } from '@src/store/user';
// 资源
import { Tabbar } from '../Tabbar';
// 样式
import './index.less';

export const WithTabbar = observer(() => {
    const { system, user } = useContext(StoreContext);
    const navigate = useNavigate();
    const { pathname } = useLocation();

    if (pathname === '/tv') {
        return null;
    }
    useEffect(() => {
        if (pathname !== '/user-auth' && user.userStatus !== UserStatusType.NORMAL) {
            navigate('user-auth');
        }
    }, [user.userStatus, navigate, pathname]);

    return (
        <div className='component-with-tabbar'>
            <div className='part-outlet'>
                <Outlet />
            </div>
            <div className='part-tabbar'>
                <Tabbar config={system?.config?.iconconfigs} noticeTitle={system?.config?.banner_tip} />
            </div>
        </div>
    );
});
